import React from 'react';
import Login from '../../Componentes/Login';
import './estilos.css';

function LoginPage() {
    
    return (
        <div className='cont-login-page'>
            <Login />
        </div>
    )
}

export default LoginPage